import shortid from 'shortid'

export enum CompanionTypes {
  Abductor = 'Abductor',
  Suspect = 'Suspect',
  FamilyAcquaintance = 'Family Acquaintance',
  Father = 'Father',
  Mother = 'Mother',
  Relative = 'Relative',
  Unknown = 'Unknown',
  Witness = 'Witness'
}

export interface IAbductor {  
  abductorId: string;
  fullName: string;
  firstName: string;
  middleName: string;
  lastName: string;
  birthDate?: any;
  age?: number;
  sex: string;
  eyeColor: string;
  hairColor: string;
  height: string;
  heightUnit: string;
  weight: string;
  weightUnit: string;
  images?: string[];
  companionType: CompanionTypes;
}

export const initialAbductor: IAbductor = 
{
  abductorId: shortid.generate(),
  fullName: "",
  firstName: "",
  middleName: "",
  lastName: "",
  sex: "",
  eyeColor: "",
  hairColor: "",
  height: "",
  heightUnit: "",
  weight: "",
  weightUnit: "",
  images: [],
  companionType: CompanionTypes.Abductor,
}
